import type { FC, SVGProps } from 'react';

type Props = Omit<SVGProps<SVGSVGElement>, 'css'>;

export const CloseIcon: FC<Props> = (props) => (
  <svg viewBox="7 7 14 14" {...props}>
    <path
      d="M20 8 8 20M20 20 8 8"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
